export default __webpack_public_path__ + "static/media/password-hidden.bd747cac.svg";